import { render, staticRenderFns } from "./template01.vue?vue&type=template&id=3afdb88c&scoped=true&"
import script from "./template01.vue?vue&type=script&lang=js&"
export * from "./template01.vue?vue&type=script&lang=js&"
import style0 from "./template01.vue?vue&type=style&index=0&id=3afdb88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afdb88c",
  null
  
)

export default component.exports